module.exports = __webpack_public_path__ + "static/media/help_select_menu.b6aeebf4.jpg";